import { fg } from '@atlassian/jira-feature-gating';

const isIncidentCommandCenterEnabledRelayProvider = {
	get(): boolean {
		return fg('jsm_incident_command_center');
	},
};

export default isIncidentCommandCenterEnabledRelayProvider;
